import Card from "@mui/material/Card";
import PropTypes from "prop-types";
import { forwardRef } from "react";

const ContainerCard = forwardRef(({ children }, ref) => {
  return (
    <Card
      ref={ref}
      sx={{
        p: 2,
        mx: { xs: 2, lg: 3 },
        mt: -8,
        mb: 4,
        backgroundColor: ({ palette: { white }, functions: { rgba } }) => rgba(white.main, 0.8),
        backdropFilter: "saturate(200%) blur(30px)",
        boxShadow: ({ boxShadows: { xxl } }) => xxl,
        overflow: "hidden",
      }}
    >
      {children}
    </Card>
  );
});

export default ContainerCard;

ContainerCard.propTypes = {
  children: PropTypes.node.isRequired,
};

ContainerCard.displayName = "ContainerCard";
